import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import userProfile from "../images/user_profile.png";
import editIcon from "../images/edit.png";
import TextInput from "./TextInput";

import { isXSmScreen, isSmScreen, isMdScreen, isValidPassword } from "../CrackersUtil";
import { BiMobile } from "react-icons/bi";
import { CrackersContext } from "../CrackersContext";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { getCarts, raisePostRequest, raisePutRequest } from "../AxiosAPI";

function AccountsPage() {
  const [smallScreen, setSmallScreen] = useState(() => isMdScreen(isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth) || isMdScreen(window.innerWidth)));
  const [mailID, setMailID] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [userName, setUserName] = useState("");
  const captionNewPassword = "Enter your new password", captionConfirmPassword = "Gives once again same password", currentPasswordCaption = "Enter your current password";
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [cPassword, setCPassword] = useState('');
  const {setShowErrorToastStatus, setToastBody, setIsZeroCasePage, userInfo, browserCart, setCarts } = useContext(CrackersContext);
  const [currentPasswordValidation, setCurrentPasswordValidation] = useState({});
  const [passwordValidation, setPasswordValidation] = useState({});
  const [cpasswordValidation, setCpasswordValidation] = useState({});
  const [showPwdCh, setShowPwdCh] = useState(false);
  const [cartsOriginal, setCartsOriginal] = useState([]);
  const [cartsCopy, setCartsCopy] = useState([]);
  const [cartsEdit, setCartsEdit] = useState(false);

  useEffect(() => {
    setIsZeroCasePage(true);
    fetchCarts();
  }, [])

  const fetchCarts = async () => {
    var cartList = await getCarts(userInfo, setShowErrorToastStatus, setToastBody, browserCart);
    var cartArray = [];
    if(cartList && cartList.length > 0) {
      for(var i=0; i<cartList.length; i++) {
        cartArray.push(cartList[i].name);
      }
      setCartsOriginal(cartArray);
      setCartsCopy(cartArray);
    }
    
  }

  const containerStyle = {
    position: "relative",
    display: "inline-block",
  };

  const profileIconStyles = {
    width: smallScreen ? "100px" : "150px",
    height: smallScreen ? "100px" : "150px",
    borderRadius: "50%",
    // objectFit: "cover",
    margin: "2%",
    opacity: "1"
  };

  const editIconStyle = {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    width: "30px",
    height: "30px",
    cursor: "pointer",
    backgroundColor: "#fff",
    borderRadius: "50%",
    padding: "5px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
  };

  useEffect(() => {
    const handleResize = () => {
      if(isXSmScreen(window.innerWidth) || isSmScreen(window.innerWidth) || isMdScreen(window.innerWidth)) {
        setSmallScreen(true);
      } else {
        setSmallScreen(false);
      }
    };

    if(userInfo) {
      setMailID(userInfo.mail_id);
      setUserName(userInfo.username);
      setMobileNumber(userInfo.mobile_number);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const validateCurrentPassword = () => {
    const errors = {};
    if (!currentPassword) {
        errors.validation = false;
        errors.reason = "Current Password is required";
        setCurrentPasswordValidation(errors);
        return false;
    } else {
      setCurrentPasswordValidation({"validation" : true});
      return true;
    }

    // const status = isValidPassword(password);
    // if(status === 'success') {
    //     setCurrentPasswordValidation({"validation" : true});
    //     return true;
    // } else {
    //     setCurrentPasswordValidation({"validation" : false, "reason" : status});
    //     return false;
    // }
  }

  const validatePassword = () => {
    const errors = {};
    if (!password) {
        errors.validation = false;
        errors.reason = "Password is required";
        setPasswordValidation(errors);
        return false;
    }

    const status = isValidPassword(password);
    if(status === 'success') {
        setPasswordValidation({"validation" : true});
        return true;
    } else {
        setPasswordValidation({"validation" : false, "reason" : status});
        return false;
    }
  }

  const validateCPassword = () => {
      const errors = {};
      if (!cPassword) {
          errors.validation = false;
          errors.reason = "Please confirm password again";
          setCpasswordValidation(errors);
          return false;
      } else if (password !== cPassword) {
          errors.validation = false;
          errors.reason = "Password and confirm password are mismatched";
          setCpasswordValidation(errors);
          return false;
      } else {
          errors.validation = true;
          setCpasswordValidation(errors);
          return true;
      }
  }

  const showPwdChangePanel = () => {
    setCurrentPassword("");
    setPassword("");
    setCPassword("");

    setCurrentPasswordValidation({});
    setPasswordValidation({});
    setCpasswordValidation({});
    setShowPwdCh(true);
  }

  const onPwdCancel = () => {
    setShowPwdCh(false);
    // setCurrentPassword("");
    // setPassword("");
    // setCPassword("");

    // setCurrentPasswordValidation({});
    // setPasswordValidation({});
    // setCpasswordValidation({});
  }

  const changePassword = async () => {
    const validation = currentPasswordValidation.validation && passwordValidation.validation && cpasswordValidation.validation;
    if(validation) {
      if(currentPassword === password) {
        const toastType = 'warning';
        const toastTitle = "Client Error - 40021";
        setToastBody({ "toastType": toastType, "toastTitle": toastTitle, "toastMessage": "Current and new passwords must be different." });
        setShowErrorToastStatus(true);
        return
      }
      const resposne = await raisePostRequest("/customer/change-pw", {"old_password" : currentPassword, "password" : password, "c_password" : cPassword}, null, setShowErrorToastStatus, setToastBody);
      if(resposne && resposne.status === 'success') {
        setCurrentPassword("");
        setPassword("");
        setCPassword("");
    
        setCurrentPasswordValidation({});
        setPasswordValidation({});
        setCpasswordValidation({});
        setShowPwdCh(true);

        const toastType = 'danger';
        const toastTitle = "Password changed";
        setToastBody({ "toastType": toastType, "toastTitle": toastTitle, "toastMessage": "Password changed successfully." });
        setShowErrorToastStatus(true);
        setShowPwdCh(false);
      }
    }
  }

  const cartNameChange = (newValue, index) => {
    setCartsOriginal(prevCarts => {
      const updated = [...prevCarts];
      updated[index] = newValue;
      return updated;
    });
  };

  const onCartsCancel = () => {
    setCartsOriginal(cartsCopy);
    setCartsEdit(false);
  }

  const updateCarts = async () => {
    const oldCarts = cartsCopy; 
    const newCarts = cartsOriginal;
    const resposne = await raisePutRequest("/carts", {"old_carts" : oldCarts, "new_carts" : newCarts}, null, setShowErrorToastStatus, setToastBody);
    if(resposne.status === "success") {
      fetchCarts();
      setCarts(cartsOriginal);
      setCartsEdit(false);
    }
  }

  return (
    <>
      <div style={{margin : smallScreen ? "5%" : "3% 20% 5% 20%"}}>
        <h1 style={{color : "#000000"}}>Profile</h1>
        <div style={{background: "white", height:"auto", opacity: "0.90", borderRadius : "10px"}}>
          <div style={{marginLeft : "1%", display : "flex", flexDirection : "row"}}>
            <div style={containerStyle}>
              <img src={userProfile} alt="Profile" style={profileIconStyles} className="img-fluid" />
              {/* <img src={editIcon} alt="Edit" style={editIconStyle} onClick={() => alert("Edit icon clicked")}/> */}
            </div>
            <div style={{display : "flex", alignItems : "center", marginLeft : "1%"}}>
              <div>
                <h3>{userName}</h3>
                <h5>{mailID}</h5>
                <h5>{mobileNumber}</h5>
                <p style={{color : "#000000", textDecoration : "underline", color : "#0000FF"}} onClick={showPwdChangePanel}>Change password</p>
              </div>
            </div>
          </div>
        </div>

        <div style={{background: "white", height:"auto", opacity: "0.90", borderRadius : "10px", marginTop : "3%", padding : "3%"}} hidden={!showPwdCh}>
          <Row>
            <Col md={3}></Col>
            <Col md={5}>
              <Row>
                  <TextInput caption={currentPasswordCaption}
                              value={currentPassword}
                              onChange={setCurrentPassword}
                              validation={currentPasswordValidation}
                              info={""}
                              onFocusCaption={"Current password"}
                              validator={validateCurrentPassword}
                              isMultiLine={false}
                              isPasswordField={true}
                              type={"password"} />
              </Row>
              <Row>
                  <TextInput caption={captionNewPassword}
                              value={password}
                              onChange={setPassword}
                              validation={passwordValidation}
                              info={"Password must be 8–16 characters and can include A–Z, a–z, 0–9, and ! @ # $ % ^ & * _ + - = ?"}
                              onFocusCaption={"New password"}
                              validator={validatePassword}
                              isMultiLine={false}
                              isPasswordField={true}
                              type={"password"} />
              </Row>
              <Row>
                  <TextInput caption={captionConfirmPassword}
                              value={cPassword}
                              onChange={setCPassword}
                              validation={cpasswordValidation}
                              info={""}
                              onFocusCaption={"Connfirm password"}
                              validator={validateCPassword}
                              isMultiLine={false}
                              isPasswordField={true}
                              type={"password"} />
              </Row>
              <Row className="d-flex justify-content-end">
              <Col xs={1}></Col>
              <Col xs={3}>
                <Button variant="light" onClick={onPwdCancel}>Cancel</Button>
              </Col>
              <Col xs={5}>
                    <Button onClick={changePassword}>Change Password</Button>
                </Col>
                  
              </Row>
            </Col>
          </Row>
          
        </div>
      </div>
      
      <div style={{ margin: smallScreen ? "5%" : "3% 20% 5% 20%" }}>
        <h1 style={{ color: "#000000" }}>Carts<img src={editIcon} style={{bottom: "10px",right: "10px",width: "30px",height: "30px",cursor: "pointer",backgroundColor: "#fff",borderRadius: "50%",padding: "5px",boxShadow: "0 2px 6px rgba(0,0,0,0.2)"}} alt="Edit"  onClick={() => setCartsEdit(true)} hidden={cartsEdit}/></h1>
        <div style={{ background: "white", height: "auto", opacity: "0.90", borderRadius: "10px", padding : "2%" }}>
          <Row>
            <Col xs={12}>
              <div style={{ marginLeft: "1%", display: "flex", flexDirection: "column" }}>
                {cartsOriginal.map((cart, index) => (
                  <TextInput
                    key={index}
                    caption={""}
                    value={cart}
                    onChange={(val) => cartNameChange(val, index)} // correct binding
                    validation={{}}
                    info={""}
                    onFocusCaption={""}
                    validator={null}
                    isMultiLine={false}
                    isPasswordField={false}
                    type={"text"}
                    styles={{ width: "200px", margin: "1%" }}
                    readOnly={cart === "Default" ? true : !cartsEdit}
                    isAlphanumeric={true}
                    lowerCaseOnly={true}
                  />
                ))}
              </div>
            </Col>
          </Row>
          <Row hidden={!cartsEdit}>
            <Col md={6} lg={8}></Col>
            <Col xs={6} sm={6} md={3} lg={2}>
              <Button onClick={onCartsCancel} variant="light">Cancel</Button>
            </Col>
            <Col xs={6} sm={6} md={3} lg={2}>
              <Button onClick={updateCarts} variant="primary">Update</Button>
            </Col>
          </Row>
        </div>
      </div>
      
    </>
    
  );
}

export default AccountsPage;
